import { render, staticRenderFns } from "./Umsatzerloese.vue?vue&type=template&id=62e8912c&"
import script from "./Umsatzerloese.vue?vue&type=script&lang=ts&"
export * from "./Umsatzerloese.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports